<app-header></app-header>
<div class="terms-and-conditions container container__custom-width">
  <article class="pt-4">
    <div [innerHtml]="getMessage"></div>
  </article>
</div>
<app-footer></app-footer>
